<template>
 <div class="container-fluid __windowHeight_">
    <div class="row h-100">
      <!--
      ==================
       import sidebar
      ==================
     -->
      <Sidebar></Sidebar>
    <!--
      ==================
       dashboard page
      ==================
     -->
      <div class="paynow_page">
        <div class="text-center __wrapper_" v-if="isLoading">
          <half-circle-spinner
            :animation-duration="750"
            :size="100"
            color="#1D3354"
            class="mx-auto"
          />
        </div>
        <div class="row justify-content-center __wrapper_" v-else-if="payment_detail">
          <div class="container_left mr-4">
            <div class="section_left mb-3">
              <div class="section_left--header" v-if="payment_detail.data" >
                <p>Payment Number:</p>
                <h4>{{payment_detail.data.payment_number}}</h4>
              </div>
              <div class="section_left--header" v-else >
                <h5 class="m-0">Invoice Number List:</h5>
              </div>
              <div class="section_left--content">
                <div class="flex-row d-flex justify-content-between countdown" v-if="payment_detail.data && payment_detail.data.method === 'va'" >
                  <div>
                    <p class="text-center">Hours to go:</p>
                    <vac :end-time="new Date (getTime(payment_detail.data.created_at))">
                      <h1
                        class="duedateblue"
                        slot="process"
                        slot-scope="{ timeObj }"> <b>{{ `${timeObj.h}:${timeObj.m}:${timeObj.s}` }}</b></h1>
                      <span class="duedateblue" slot="finish">Done!</span>
                    </vac>
                  </div>
                  <div class="d-flex align-self-end">
                    <p>Please complete your payment <br> in 1 x24 hours</p>
                  </div>
                </div>

                <div class="invoice_list">
                  <p class="title" v-if="payment_detail.data && payment_detail.data.payment_number"><b>Invoice Number List:</b></p>
                  <ol>
                    <li v-for="(item,i) in payment_detail.invoiceList" :key="i"> {{item}} </li>
                  </ol>
                </div>

                <div class="d-flex justify-content-end">
                  <div class="total_amount">
                    <div class="row m-0">
                      <div class="mr-2">
                        <p><b>Total Invoice</b></p>
                        <p><b>Total Amount of Payment</b></p>
                      </div>
                      <div v-if="payment_detail.invoiceList">
                        <p><b>: {{payment_detail.invoiceList.length}}</b></p>
                        <p><b>: {{payment_detail.total | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true })}}</b></p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div class="section_left" v-if="!payment_detail.data">
              <div class="section_left--header">
                <h5 class="m-0">Payment Method</h5>
                <!-- <p>Please Select One of The Following Payment Method :</p> -->
              </div>
              <div class="section_left--content">
                  <b-form-group>
                     <b-form-radio-group
                     class="row m-0 justify-content-around"
                      v-model="payment_method"
                      :options="options"
                      name="radio-options"
                    ></b-form-radio-group>
                  </b-form-group>
              </div>
            </div>
            <div class="button__process row m-0 justify-content-end mt-4" v-if="!payment_detail.data">
              <router-link :to="{name: 'Payment', type: 'unpaid'}">
                <button class="button__bluesmall p-0 px-3 mr-3">Back</button>
               </router-link>
              <button @click="process_payment" class="button__bluesmall p-0 px-3">Process Payment</button>
            </div>
          </div>
          <div class="container_right" v-if="this.payment_detail.data">
            <div class="section_right">
              <div class="section_right--header text-center align-items-center">
                <p class="mb-2"><b>Payment Method</b></p>
                <p style="font-size: 14px; line-height: 1.27;">Please input the amount correctly as instructed <br> otherwise it will slow your payment verification process.  </p>
              </div>
              <div class="text-center" style="padding: 0px 20px 20px 20px">
                <p v-if="this.payment_detail.data.method === 'va'">Virtual Account Number:</p>
                <p v-if="this.payment_detail.data.method === 'transfer'">Bank Account Number:</p>
                <div class="row m-0 mt-2 justify-content-between align-items-center">
                  <img v-if="this.payment_detail.data.bank === 'BCA'" src="@/assets/image/icon/BCA_logo.png" alt="">
                  <img v-else src="@/assets/image/icon/BCA_logo.png" alt="">
                  <span class="pb-1 pt-1 pl-3 pr-3">
                    {{
                      (payment_detail.data.method === 'transfer' && payment_detail.data.bank === 'BNI')
                      ? '2911878828'
                      : (payment_detail.data.method === 'transfer' && payment_detail.data.bank === 'BCA')
                      ? '2913188098'
                      : (payment_detail.data.method === 'va')
                      ? payment_detail.data.virtual_account : ''
                    }}
                  </span>
                  <button class="_global__button--corporite"
                    id="tooltip-1"
                    v-clipboard:copy="copyText"
                    @click="handleCopyStatus(true)"
                    @mouseout="handleCopyStatus(false)"
                    v-b-tooltip.hover :title="tooltipText"
                    >
                      Copy
                  </button>
                </div>
                <p class="text-left mt-2" v-if="this.payment_detail.data.method === 'transfer'">Acc Name: PT. Eximku Logistik Indonesia</p>
              </div>
              <div class="payment_guide">
                <p style="height: 30px;"><b class="ml-2">Payment Guide</b></p>
                <div class="collapse_1" v-b-toggle.accordion-1 v-if="this.payment_detail.data.method === 'va'">
                  <div class="d-flex align-items-center justify-content-between" style="height: 28px;">
                    <p class="ml-2">Internet Banking </p>
                    <img  class="mr-2 arrow__customs"
                    src="@/assets/image/icon/left-arrow-blue.svg" alt="">
                  </div>
                  <b-collapse id="accordion-1">
                    <ol>
                      <li>Login in KlikBCA Apps</li>
                      <li>Choose Transfer > Transfer to BCA Virtual Account</li>
                      <li>Insert BCA Virtual Account Number > Choose Continue</li>
                      <li>Check the details > click Continue</li>
                      <li>Insert Response KeyBCA > choose send</li>
                    </ol>
                  </b-collapse>
                </div>
                <div class="collapse_2" v-b-toggle.accordion-2>
                  <div class="d-flex align-items-center justify-content-between" style="height: 28px;">
                    <p class="ml-2">Bank Transfer </p>
                    <img  class="mr-2 arrow__customs"
                    src="@/assets/image/icon/left-arrow-blue.svg" alt="">
                  </div>
                  <b-collapse id="accordion-2">
                    <ol v-if="this.payment_detail.data.method === 'va'">
                      <li>Fill out the deposit form including BCA Virtual Account Number and other details</li>
                      <li>Fill Account Number Section with BCA Virtual Account Number</li>
                      <li>Fill Account Number Section with BCA Virtual Account Number Fill username with your name</li>
                      <li>In the News section type your name > choose Indonesian Rupiah for the currency > the amount of your payment</li>
                      <li>Keep the payment slip receipt as your proof of payment.</li>
                    </ol>
                    <ol v-else>
                      <li>Fill out the deposit form including BCA Account Number and other details</li>
                      <li>Fill Account Number Section with BCA Account Number</li>
                      <li>Fill Account Number Section with BCA Account Number Fill username with your name</li>
                      <li>In the News section type your name > choose Indonesian Rupiah for the currency > the amount of your payment</li>
                      <li>Keep the payment slip receipt as your proof of payment.</li>
                    </ol>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="text-center">
          <router-link :to="{name: 'Payment', params: {type: 'unpaid'}}">
            <button class="button__bluesmall p-0 px-3 mr-3">Back to Unpaid Payment</button>
          </router-link>
        </div>
      </div>
    </div>
 </div>
</template>

<script>
import Sidebar from '@/components/global/Sidebar.vue'
import { HalfCircleSpinner } from 'epic-spinners'
import { mapGetters } from 'vuex'
import * as momentTimezone from 'moment-timezone'
import { PAYMENT_PAY_NOW } from '@/constant/localStorage'

export default {
  name: 'paymentNow',
  components: {
    Sidebar,
    HalfCircleSpinner
  },
  data () {
    return {
      noVa: 'XXXXXYYMMDD00001',
      copyText: '',
      tooltipText: '',
      disabled: true,
      payment_method: 'BCAT',
      payment_detail: JSON.parse(localStorage.getItem(PAYMENT_PAY_NOW)) || null,
      options: [
        { text: 'BCA Bank Transfer', value: 'BCAT' }
        // hide VA & BNI transfer
        // { text: 'BNI Bank Transfer', value: 'BNIT' },
        // { text: 'BCA Virtual Account', value: 'BCAV', disabled: false }
      ]
    }
  },
  methods: {
    init () {
      const data = this.invoices
      let paymentDetail = this.payment_detail
      paymentDetail.idInvoice = data.idInvoice
      paymentDetail.invoiceList = data.invoiceList
      paymentDetail.total = data.total
    },
    process_payment () {
      const payload = Object.assign(
        { id_invoice: this.payment_detail.idInvoice },
        { bank: (this.payment_method === 'BNIT') ? 'BNI' : 'BCA' },
        { method: (this.payment_method === 'BCAV') ? 'va' : 'transfer' },
        { typeOfPayment: 'FULL' })
      this.$store.dispatch('payment/CREATE_PAYMENT', payload)
    },
    handleCopyStatus (item) {
      this.tooltipText = item ? 'Copied' : ''
    },
    processPayment () {
      this.$eventHub.$emit('dialog-process-invoice')
    },
    getTime (date) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      const newDate = momentTimezone(date).tz(timezone).add(24, 'h').format('YYYY-MM-DD HH:mm:ss')
      return newDate
    }

  },
  mounted () {
    this.$store.dispatch('payment/PAYMENT_PROCESS_TEMP')
  },
  computed: {
    ...mapGetters({
      invoices: 'payment/dataTemp',
      payment: 'payment/createPayment',
      isLoading: 'payment/isLoadingCreatePayment',
      isError: 'payment/errorCreatePayment'
    })
  },
  watch: {
    payment (data) {
      if (data) {
        Object.assign(this.payment_detail, {data: data})
        if (this.payment_detail.data.method === 'transfer' && this.payment_detail.data.bank === 'BNI') {
          this.copyText = '2911878828'
        } else if (this.payment_detail.data.method === 'transfer' && this.payment_detail.data.bank === 'BCA') {
          this.copyText = '2913188098'
        } else { this.copyText = this.payment_detail.data.virtual_account }
      }
    },
    payment_detail (data) {
      if (data) {
        if (data.data.method === 'transfer' && data.data.bank === 'BNI') {
          this.copyText = '2911878828'
        } else if (data.data.method === 'transfer' && data.data.bank === 'BCA') {
          this.copyText = '2913188098'
        } else { this.copyText = data.data.virtual_account }
      }
    },
    isError (data) {
      if (data) {
        this.$eventHub.$emit('dialog-payment-rejected', data.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/paymentNow/index.vue